import { createGlobalStyle } from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

import { FontStyles } from './FontStyles';

import { getDeviceSize } from 'helpers';
import { MAX } from 'consts';

import { fade, collapse } from './transitions';

export const GlobalStyles = createGlobalStyle`
    :root {
      --main-font: normal normal 14px 'Museo Sans Cyrl', sans-serif;
      --min-mobile-width: 320px;
      --min-tablet-width: 768px;
      --min-laptop-width: 1366px;
      --min-desktop-width: 1600px;
    }

    html,
    body {
        font: var(--main-font);
        font-size: 16px;
        line-height: 16px;
        background-color: #EAEDF5;
    }

    .ant-table-body {
        background: ${colors.gray0};
    }

    tr.ant-table-expanded-row > td {
        border: none;
    }

    .ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table{
    }

    .ant-table-expanded-row > td > .ant-table-wrapper > .ant-spin-nested-loading > .ant-table-container {
        border-radius: 0;
    }

    button.ant-table-row-expand-icon.ant-table-row-expand-icon-collapsed, 
    button.ant-table-row-expand-icon.ant-table-row-expand-icon-expanded {
        margin: 0px 12px 0 5px;
        border-color: #BDC5DB;
        border-radius: 4px;
    }

    .ant-table.ant-table-bordered > .ant-table-container {
        border-left: none;
    }

    .ant-table-expanded-row-fixed {
        white-space: pre;
    }

    .ant-drawer-content-wrapper {
        height: calc(-80px + 100vh) !important;
    }

    .ant-modal {
        @media (${getDeviceSize(MAX).tablet}) {
            position: absolute;
            width: 100% !important;
            max-width: 100%;
            height: 100%;
            top: 0px;
            bottom: 0;
            margin: 0;
            padding: 0;
        }
    }

    .ant-modal-content {
        @media (${getDeviceSize(MAX).tablet}) {
            width: 100%;
            height: fit-content;
            border-radius: 0 !important;
        }
    }

    .ant-modal-title{
        @media (${getDeviceSize(MAX).tablet}) {
            font-size: 20px;
        }
    }

    .ant-modal-header{
        @media (${getDeviceSize(MAX).tablet}) {
            border: none;
        }
    }

    .ant-modal-body{
        @media (${getDeviceSize(MAX).tablet}) {
            padding-top: 0;
            height: fit-content;
            overflow: scroll;
        }
    }

    ${fade}
    ${collapse}
    ${FontStyles}
`;
